import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { supabase } from '@/integrations/supabase/client';
import { usePricingModal } from '@/context/PricingModalContext';

interface ViewLimitModalProps {
  threshold: number;
  onClose: () => void;
}

export function ViewLimitModal({ threshold, onClose }: ViewLimitModalProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { openPricingModal } = usePricingModal();

  const handleCtaClick = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    
    if (user) {
      onClose();
      openPricingModal();
    } else {
      const next = encodeURIComponent(location.pathname + location.search);
      navigate(`/auth/signin?next=${next}`);
    }
  };

  return (
    <div className="fixed inset-0 z-50 grid place-items-center bg-black/50 p-4">
      <div className="w-[min(94vw,520px)] rounded-2xl bg-background shadow-2xl p-6 border border-black/15">
        <h3 className="text-xl font-semibold">Create your account to continue exploring winning ads</h3>
        <p className="mt-2 text-sm text-muted-foreground">
          You've reached your free {threshold}-ad limit. Unlock unlimited browsing with a free account and subscribe anytime.
        </p>
        <div className="mt-5 flex gap-3">
          <button 
            onClick={handleCtaClick}
            className="h-11 px-4 rounded-md bg-primary text-primary-foreground font-medium w-full hover:bg-primary/90"
          >
            Create account
          </button>
          <button 
            onClick={onClose}
            className="h-11 px-4 rounded-md border border-black/15 bg-background hover:bg-accent w-full"
          >
            Not now
          </button>
        </div>
        <p className="mt-3 text-xs text-muted-foreground text-center">
          Already a member? You'll be taken to sign in.
        </p>
      </div>
    </div>
  );
}
